/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SuccessInputs */

const en_success = /** @type {(inputs: SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success!`)
};

const fr_success = /** @type {(inputs: SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès !`)
};

const de_success = /** @type {(inputs: SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfolg!`)
};

const it_success = /** @type {(inputs: SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successo!`)
};

const ru_success = /** @type {(inputs: SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Успех!`)
};

const es_success = /** @type {(inputs: SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Éxito!`)
};

const zh_cn2_success = /** @type {(inputs: SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成功！`)
};

const ja_success = /** @type {(inputs: SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成功！`)
};

const hi_success = /** @type {(inputs: SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सफलता!`)
};

const pt_pt2_success = /** @type {(inputs: SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sucesso!`)
};

/**
* | output |
* | --- |
* | "Success!" |
*
* @param {SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const success = /** @type {((inputs?: SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_success(inputs)
	if (locale === "de") return de_success(inputs)
	if (locale === "it") return it_success(inputs)
	if (locale === "ru") return ru_success(inputs)
	if (locale === "es") return es_success(inputs)
	if (locale === "zh-CN") return zh_cn2_success(inputs)
	if (locale === "ja") return ja_success(inputs)
	if (locale === "hi") return hi_success(inputs)
	if (locale === "pt-PT") return pt_pt2_success(inputs)
	return en_success(inputs)
});